"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileManagerPortalData;

var _immutable = _interopRequireDefault(require("immutable"));

var _ActionTypes = _interopRequireDefault(require("FileManagerCore/actions/ActionTypes"));

var _Constants = require("FileManagerCore/Constants");

var _FileManagerPortalData = require("FileManagerCore/utils/FileManagerPortalData");

var FileManagerPortalDataDefaultState = _immutable.default.Map({
  vidyardTosStatus: _Constants.VidyardTosStatus.NOT_ASKED,
  isVideoPQLBannerDismissed: true,
  updateRequestStatus: _Constants.RequestStatus.UNINITIALIZED,
  fetchRequestStatus: _Constants.RequestStatus.UNINITIALIZED
});

function FileManagerPortalData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : FileManagerPortalDataDefaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      vidyardTosStatus = action.vidyardTosStatus,
      portalDataList = action.portalDataList;

  switch (type) {
    case _ActionTypes.default.UPDATE_VIDYARD_TOS_STATUS_ATTEMPTED:
      return state.merge({
        updateRequestStatus: _Constants.RequestStatus.PENDING
      });

    case _ActionTypes.default.UPDATE_VIDYARD_TOS_STATUS_SUCCEEDED:
      return state.merge({
        vidyardTosStatus: vidyardTosStatus,
        updateRequestStatus: _Constants.RequestStatus.SUCCEEDED
      });

    case _ActionTypes.default.UPDATE_VIDYARD_TOS_STATUS_FAILED:
      return state.merge({
        updateRequestStatus: _Constants.RequestStatus.FAILED
      });

    case _ActionTypes.default.FETCH_FILE_MANAGER_PORTAL_DATA_SUCCEEDED:
      return state.merge({
        vidyardTosStatus: (0, _FileManagerPortalData.getVidyardTosStatus)((0, _FileManagerPortalData.getVidyardTosMap)(portalDataList)),
        isVideoPQLBannerDismissed: (0, _FileManagerPortalData.getIsVideoPQLBannerDismissed)((0, _FileManagerPortalData.getVideoPQLMap)(portalDataList)),
        fetchRequestStatus: _Constants.RequestStatus.SUCCEEDED
      });

    default:
      return state;
  }
}

module.exports = exports.default;